// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nqrpggtzJxE3mYObSuNR{padding:0}.adyfr6obW34x19WfQiqG{justify-content:center;align-items:center;width:40px;height:40px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxCell": `nqrpggtzJxE3mYObSuNR`,
	"wrapCheckbox": `adyfr6obW34x19WfQiqG`
};
export default ___CSS_LOADER_EXPORT___;
